import { jsx as e } from "react/jsx-runtime";
import { useStyleEngine as s } from "@telegraph/style-engine";
import d from "clsx";
const r = {
  display: {
    cssVar: "--display",
    value: "VARIABLE"
  },
  backgroundColor: {
    cssVar: "--background-color",
    value: "var(--tgph-VARIABLE)"
  },
  hover_backgroundColor: {
    cssVar: "--hover_backgroundColor",
    value: "var(--tgph-VARIABLE)",
    interactive: !0
  },
  focus_backgroundColor: {
    cssVar: "--focus_backgroundColor",
    value: "var(--tgph-VARIABLE)",
    interactive: !0
  },
  active_backgroundColor: {
    cssVar: "--active_backgroundColor",
    interactive: !0,
    value: "var(--tgph-VARIABLE)"
  },
  borderStyle: {
    cssVar: "--border-style",
    value: "var(--tgph-border-style-VARIABLE)"
  },
  padding: {
    cssVar: "--padding",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "all"
  },
  paddingX: {
    cssVar: "--padding",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "x"
  },
  paddingY: {
    cssVar: "--padding",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "y"
  },
  paddingTop: {
    cssVar: "--padding",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "top"
  },
  paddingBottom: {
    cssVar: "--padding",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "bottom"
  },
  paddingLeft: {
    cssVar: "--padding",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "left"
  },
  paddingRight: {
    cssVar: "--padding",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "right"
  },
  margin: {
    cssVar: "--margin",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  marginX: {
    cssVar: "--margin",
    value: "0 var(--tgph-spacing-VARIABLE)"
  },
  marginY: {
    cssVar: "--margin",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "y"
  },
  marginTop: {
    cssVar: "--margin",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "top"
  },
  marginBottom: {
    cssVar: "--margin",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "bottom"
  },
  marginLeft: {
    cssVar: "--margin",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "left"
  },
  marginRight: {
    cssVar: "--margin",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "right"
  },
  borderColor: {
    cssVar: "--border-color",
    value: "var(--tgph-VARIABLE)"
  },
  borderWidth: {
    cssVar: "--border-width",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  borderTopWidth: {
    cssVar: "--border-width",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "top"
  },
  borderBottomWidth: {
    cssVar: "--border-width",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "bottom"
  },
  borderLeftWidth: {
    cssVar: "--border-width",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "left"
  },
  borderRightWidth: {
    cssVar: "--border-width",
    value: "var(--tgph-spacing-VARIABLE)",
    direction: "right"
  },
  borderRadius: {
    cssVar: "--border-radius",
    value: "var(--tgph-rounded-VARIABLE)"
  },
  borderTopLeftRadius: {
    cssVar: "--border-radius",
    value: "var(--tgph-rounded-VARIABLE)",
    direction: "top"
  },
  borderTopRightRadius: {
    cssVar: "--border-radius",
    value: "var(--tgph-rounded-VARIABLE)",
    direction: "right"
  },
  borderBottomLeftRadius: {
    cssVar: "--border-radius",
    value: "var(--tgph-rounded-VARIABLE)",
    direction: "left"
  },
  borderBottomRightRadius: {
    cssVar: "--border-radius",
    value: "var(--tgph-rounded-VARIABLE)",
    direction: "bottom"
  },
  borderTopRadius: {
    cssVar: "--border-radius",
    value: "var(--tgph-rounded-VARIABLE)",
    direction: "side-top"
  },
  borderBottomRadius: {
    cssVar: "--border-radius",
    value: "var(--tgph-rounded-VARIABLE)",
    direction: "side-bottom"
  },
  borderLeftRadius: {
    cssVar: "--border-radius",
    value: "var(--tgph-rounded-VARIABLE)",
    direction: "side-left"
  },
  borderRightRadius: {
    cssVar: "--border-radius",
    value: "var(--tgph-rounded-VARIABLE)",
    direction: "side-right"
  },
  boxShadow: {
    cssVar: "--box-shadow",
    value: "var(--tgph-shadow-VARIABLE)"
  },
  width: {
    cssVar: "--width",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  height: {
    cssVar: "--height",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  minWidth: {
    cssVar: "--min-width",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  minHeight: {
    cssVar: "--min-height",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  maxWidth: {
    cssVar: "--max-width",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  maxHeight: {
    cssVar: "--max-height",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  zIndex: {
    cssVar: "--z-index",
    value: "var(--tgph-zIndex-VARIABLE)"
  },
  position: {
    cssVar: "--position",
    value: "VARIABLE"
  },
  top: {
    cssVar: "--top",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  left: {
    cssVar: "--left",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  right: {
    cssVar: "--right",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  bottom: {
    cssVar: "--bottom",
    value: "var(--tgph-spacing-VARIABLE)"
  },
  overflow: {
    cssVar: "--overflow",
    value: "VARIABLE"
  }
}, u = {
  border: r.borderWidth,
  borderX: r.borderLeftWidth,
  borderY: r.borderTopWidth,
  bg: r.backgroundColor,
  p: r.padding,
  m: r.margin,
  px: r.paddingX,
  py: r.paddingY,
  pt: r.paddingTop,
  pb: r.paddingBottom,
  pl: r.paddingLeft,
  pr: r.paddingRight,
  mx: r.marginX,
  my: r.marginY,
  mt: r.marginTop,
  mb: r.marginBottom,
  ml: r.marginLeft,
  mr: r.marginRight,
  shadow: r.boxShadow,
  w: r.width,
  h: r.height,
  minW: r.minWidth,
  minH: r.minHeight,
  maxW: r.maxWidth,
  maxH: r.maxHeight,
  rounded: r.borderRadius,
  roundedTopLeft: r.borderTopLeftRadius,
  roundedTopRight: r.borderTopRightRadius,
  roundedBottomLeft: r.borderBottomLeftRadius,
  roundedBottomRight: r.borderBottomRightRadius,
  roundedTop: r.borderTopRadius,
  roundedBottom: r.borderBottomRadius,
  roundedLeft: r.borderLeftRadius,
  roundedRight: r.borderRightRadius,
  borderTop: r.borderTopWidth,
  borderBottom: r.borderBottomWidth,
  borderLeft: r.borderLeftWidth,
  borderRight: r.borderRightWidth
}, V = {
  ...r,
  ...u
}, v = ({
  as: a,
  className: t,
  tgphRef: i,
  children: o,
  ...g
}) => {
  const n = a || "div", { styleProp: c, otherProps: p, interactive: h } = s({
    props: g,
    cssVars: V
  });
  return /* @__PURE__ */ e(
    n,
    {
      className: d(
        "tgph-box",
        h && "tgph-box--interactive",
        t
      ),
      style: c,
      ...p,
      ref: i,
      children: o
    }
  );
}, A = {
  flexDirection: {
    cssVar: "--direction",
    value: "VARIABLE"
  },
  flexWrap: {
    cssVar: "--wrap",
    value: "VARIABLE"
  },
  justifyContent: {
    cssVar: "--justify",
    value: "VARIABLE"
  },
  alignItems: {
    cssVar: "--align",
    value: "VARIABLE"
  },
  gap: {
    cssVar: "--gap",
    value: "var(--tgph-spacing-VARIABLE)"
  }
}, l = {
  direction: {
    cssVar: "--direction",
    value: "VARIABLE"
  },
  align: {
    cssVar: "--align",
    value: "VARIABLE"
  },
  justify: {
    cssVar: "--justify",
    value: "VARIABLE"
  },
  wrap: {
    cssVar: "--wrap",
    value: "VARIABLE"
  }
}, R = {
  ...A,
  ...l
}, L = ({
  className: a,
  ...t
}) => {
  const { styleProp: i, otherProps: o } = s({
    props: t,
    cssVars: R
  });
  return /* @__PURE__ */ e(
    v,
    {
      className: d("tgph-stack", a),
      style: i,
      ...o
    }
  );
};
export {
  v as Box,
  L as Stack
};
//# sourceMappingURL=index.mjs.map
